import { ulid } from 'ulidx';
import YAML from 'yaml';
export default class UIComponent {
    name;
    dataIndex;
    structure;
    children;
    constructor(s) {
        this.structure = s;
        this.name = this.getProperty('name', ulid());
        this.dataIndex = this.getProperty('dataIndex', '');
        this.children = [];
    }
    getByName(name) {
        if (this.name === name) {
            return this;
        }
        for (const c of this.children) {
            const result = c.getByName(name);
            if (result !== undefined) {
                return result;
            }
        }
        return undefined;
    }
    getByPartialName(name) {
        let matches = [];
        if (this.name.startsWith(name)) {
            matches.push(this);
        }
        for (const child of this.children) {
            const childMatches = child.getByPartialName(name);
            if (childMatches) {
                matches.push(...childMatches);
            }
        }
        return matches.length > 0 ? matches : undefined;
    }
    getByDataIndex(dataIndex) {
        if (this.dataIndex === dataIndex) {
            return this;
        }
        for (const c of this.children) {
            const result = c.getByDataIndex(dataIndex);
            if (result !== undefined) {
                return result;
            }
        }
        return undefined;
    }
    getProperty(name, defaultValue = undefined) {
        if (name in this.structure) {
            const value = this.structure[name];
            if (value != '') {
                return value;
            }
        }
        else {
            if (defaultValue !== undefined) {
                return defaultValue;
            }
        }
        throw Error(`Property ${name} does not exist near: ${YAML.stringify(this.structure)}`);
    }
}
//# sourceMappingURL=uiComponent.js.map